const metricTooltips = {
  "tooltip.scan_frequency.description": "How often do you look away from the ball throughout the scenario.",
  "tooltip.scan_frequency.scans_per_second.unit": "Scans/second",
  "tooltip.scan_frequency.how_measured": "How it's measured",
  "tooltip.scan_frequency.scans_per_second": "You're scored on how many scans you do per second throughout each scenario.",
  "tooltip.scan_frequency.tip": "Tip: Check your surroundings often, but remember to look back at the ball!",

  "tooltip.scan_timing.description": "Are you looking at the ball and looking away from it in the correct moments?",
  "tooltip.scan_timing.scans_per_second.unit": "Percentage of well timed scans/total scans",
  "tooltip.scan_timing.how_measured": "How it's measured",
  "tooltip.scan_timing.scans_per_second": "You're scored on how accurate your timing is throughout each scenario.",
  "tooltip.scan_timing.tip": "Tip: look at the ball when players are in contact with it (passing or dribbling), check your surroundings when the ball is in flight (pass) or away from the player's foot (dribbling).",

  "tooltip.awareness.description": "How much information you recognize and remember at any point in the scenario.",
  "tooltip.awareness.how_measured": "How it's measured",
  "tooltip.awareness.score_explanation": "You're scored on how many correct answers you get in the random Awareness Tests that might appear throughout your training session.",
  "tooltip.awareness.tip": "Tip: as you perform your scans focus on the details of the situation around you, remembering what you see!",
  "tooltip.awareness.score_explanation.unit": "Percentage of correct answers",

  "tooltip.critical_scan.description": "Performing at least one scan as the ball is coming towards you.",
  "tooltip.critical_scan.how_measured": "How it's measured",
  "tooltip.critical_scan.score_explanation": "You're scored on how many times you successfully scan before receiving the ball.",
  "tooltip.critical_scan.tip": "Tip: challenge yourself to look away from the ball as it is in flight towards you, make sure to look back at the ball to receive it!",
  "tooltip.critical_scan.score_explanation.unit": "Total critical scans/receivals",

  "tooltip.decision.description": "Rates your passing choice or shooting accuracy.",
  "tooltip.decision.how_measured": "How it's measured",
  "tooltip.decision.score_explanation": "You get scored on the quality of your passing choice (based on visual clues) or accuracy of your shooting",
  "tooltip.decision.tip": "Tip: look for visual clues: space, acceleration, scoring opportunities or hand signals.",
  "tooltip.decision.score_explanation.unit": "Percentage of decision scores",
};

export default metricTooltips;
